<script>
  import LogoNav from '@/library/logo/nav.svelte';
  import NavBar from '@/library/nav/bar.svelte';

  import ContentOverlay from '@/library/overlay/absolute/full-centre.svelte';
  import TintedOverlay from '@/library/overlay/absolute/tinted-gradient.svelte';
  import Image from '@/library/image/cover-image.svelte';

  export let feature;

  let layout = feature.layout;
  // let pretext = feature.content.pretext;
  let context = feature.content.context;
  // let subtext = feature.content.subtext;
  // let meta = feature.meta;

  // function scrollUp(event) {
  //   window.scrollTo(0,0);
  // }

</script>

<style></style>

<!-- <section onload={scrollUp()} id="feature"> -->
<section class="" id="feature">
  <ContentOverlay>
    <div class="h-full fc jb px-sm">
      <nav class="fr ic jb py-sm">
        <LogoNav logo={layout.logo} />
        <!-- obj={} -->
        <NavBar navs={layout.navs} />
      </nav>
      <div class="max-w-md py-md">
        <h2>{context.title}</h2>
      </div>
    </div>
  </ContentOverlay>

  <TintedOverlay />
  <Image image={context.image} />
  
</section>